import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { TableComponentProps } from '../types';

const columnLables = {
  // aif_identifier_lei: {
  //   name: 'Legal Entity Identification code (LEI)',
  //   order: 6,
  // },
  // aif_identifier_isin: {
  //   name: 'International Securities Identification Number (ISIN)',
  //   order: 7,
  // },
  // aif_identifier_cusip: {
  //   name: 'Commodities on Uniform Securities Identification Procedures Number (CUSIP)',
  //   order: 8,
  // },
  // aif_identifier_sedol: {
  //   name: 'Stock Exchange Daily Official List code (SEDOL)',
  //   order: 9,
  // },
  // aif_identifier_ticker: {
  //   name: 'Bloomberg (ticker) code',
  //   order: 10,
  // },
  // aif_identifier_ric: {
  //   name: 'Reuters Instrument Code (RIC)',
  //   order: 11,
  // },
  // inception_date: {
  //   name: 'Inception date of the fund',
  //   order: 15,
  // },
  // reporting_period_type: {
  //   name: 'Reporting period type',
  //   order: 16,
  // },
  // reporting_period_start_date: {
  //   name: 'Start date',
  //   order: 17,
  // },
  // reporting_period_end_date: {
  //   name: 'End date',
  //   order: 18,
  // },
  // reporting_period_year: {
  //   name: 'Year',
  //   order: 19,
  // },
  filing_type: {
    name: 'Filing type',
    order: 4
  },
  // aif_reporting_code: {
  //   name: 'AIF Reporting Code',
  //   order: 249,
  // },
  aif_content_type: {
    name: 'AIF Content type',
    order: 5
  },
  reporting_period_start_date: {
    name: 'Reporting period start date',
    order: 6
  },
  reporting_period_end_date: {
    name: 'Reporting period end date',
    order: 7
  },
  reporting_period_type: {
    name: 'Reporting period type',
    order: 8
  },
  reporting_period_year: {
    name: 'Reporting period year',
    order: 9
  },
  aif_reporting_obligation_change_frequency_code: {
    name: 'Change in AIF reporting obligation frequency Code',
    order: 10
  },
  aif_reporting_obligation_change_contents_code: {
    name: 'Change in AIF reporting obligation contents Code',
    order: 11
  },

  aif_reporting_obligation_change_quarter: {
    name: 'Change in AIF reporting obligation Quarter	',
    order: 12
  },

  last_reporting_flag: {
    name: 'Last reporting flag',
    order: 13,
    disabled: true
  }
  // aif_no_reporting_flag: {
  //   name: `Do you wish to submit a nil return?
  //   (If 'Yes', only fields 1A to 5A and 15A to 26A must be completed where applicable)`,
  //   order: 26,
  // },
};

export const FundIdentificationCodes = ({
  funds,
  currentDataKey,
  onChangeFund,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) => {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.HEADER_SECTION,
    onChangeFund,
    schema: schema.HEADER_SECTION,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.HEADER_SECTION?.field_names || [],
    isMultiFunds,
    funds,
    columnLables,
    tableName: 'HEADER_SECTION'
  });

  return (
    <Table
      id="reporttables-fund-identification-codes-table"
      handleChanges={onChange}
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
      stickyTopRows={isMultiFunds ? 1 : null}
      columns={columns}
      rows={rows}
    />
  );
};
